import { createSlice } from "@reduxjs/toolkit";
import {
  viewTeams,
  singleTeams,
  registerTeams,
  updateTeams,
  deleteTeams,
} from "../actions/teamsAction";

const newsSlice = createSlice({
  name: "teams",
  initialState: {
    teams: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(updateTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(deleteTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(singleTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.teams = action.payload;
      })
      .addCase(registerTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(viewTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
